/*eslint-disable*/
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Tooltip from "@material-ui/core/Tooltip";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import Table from "components/Table/Table.js";
import Close from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import Icon from "@material-ui/core/Icon";
import { FiPhoneCall } from "react-icons/fi";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import SweetAlert from "react-bootstrap-sweetalert";
import BillHeader from "views/BanglesPage/Cart/BillHeader";
import ClientDetails from "views/BanglesPage/Cart/ClientDetails";
import invoiceStyle from "assets/jss/material-kit-pro-react/views/invoiceTableStyle";
import listCart from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.js";
import popOver from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";

import axios from "axios";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles(invoiceStyle);
const useStyle = makeStyles(listCart);
const useStylPop = makeStyles(popOver);
const useStyleAlert = makeStyles(style);


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function EorderForm() {
  const [addCart, setAddCart] = React.useState([]);
  const [userId, setUserId] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [mobileErr, setMobileErr] = React.useState("");
  const [otpNumber, setOtpNumber] = React.useState("");
  const [otpNumberErr, setOtpNumberErr] = React.useState("");
  const [otpScreen, setOtpScreen] = React.useState(false);
  const [otp, setOtp] = React.useState("");
  const [reSend, setReSend] = React.useState("");
  const [loginModal, setLoginModal] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [submittedConfirm, setSubmittedConfirm] = React.useState(false);
  const [alertMsg, alertMsgOps] = React.useState("");
  const [alertType, alertTypeOps] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [cardId, setCartId] = React.useState();
  const [updateDate, setUpdateDate] = React.useState("");
  const [load, setLoad] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const history = useHistory();
  const classPop = useStylPop();
  const classeAlert = useStyleAlert();

  const search = useLocation().search;
  const byuserid = new URLSearchParams(search).get('byuserid');
  const clientid = new URLSearchParams(search).get('clientid');
  const expdate = new URLSearchParams(search).get('expdate');

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const handleSendOtp = () => {
    let errorCount = 0;
    if (!mobile || mobile.length < 12) {
      errorCount++;
      setMobileErr("Please Enter 10 digit Mobile Number");
    }
    if (errorCount === 0) {
      fetch(
        headApi + `/user/sendotp?mobile=+${mobile === clientid ? mobile : ""}&type=client&webappid=6`,
        {
          method: "PUT"
          // headers: {
          //   "content-type": "application/json",
          //   accept: "application/json",
          // },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          if (response.message === "Enter Registerd Mobile number") {
            setMobileErr("Please Enter Registerd Mobile number");
          }
          if(response.message === "Please Enter Valid Mobile Number"){
            setMobileErr("Please Enter Valid Mobile Number");
          }
          if (response && response.error === "false") {
            setOtpScreen({ otpScreen: true });
            setOtp(response.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleOtp = (e) => {
    setOtpNumber(e.target.value);
    setOtpNumberErr("");
  };

  const handleLogin = () => {
    let errCount = 0;
    if (otpNumber.length !== 6) {
      errCount++;
      setOtpNumberErr("Invalid OTP");
    }

    if (errCount === 0) {
      fetch(
        headApi + `/user/login?otp=${otpNumber}&mobile=+${mobile}&type=client`,
        {
          method: "PUT"
          // headers: {
          //   "content-type": "application/json",
          //   accept: "application/json",
          // },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          if (response.apiResponse.error !== "false") return false;
          const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          history.push("/cart-shipping-address");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleCall = (e) => {
    e.preventDefault();
    fetch(
      headApi + `/user/callMe?mobile=+${mobile}&webappid=6`,
      {
        method: "GET"
        // headers: {
        //   "content-type": "application/json",
        //   accept: "application/json",
        // },
      }
    )
      .then((response) => response.json())
      .then((response) => {
        if (response === "Thank You for Visiting! We will reach back to you soon.") {
          alert("Thank You for Visiting! We will reach back to you soon.");
          }
      });
  };

  // const date = Intl.DateTimeFormat("fr-CA", {
  //   year: "numeric",
  //   month: "numeric",
  //   day: "numeric",
  // }).format(new Date()).replaceAll('/', '-');

  // const current = new Date();
  // const dateCurrent = `${current.getDate()}-${current.getMonth() + 1}-${current.getFullYear()}`;
  // current.setDate(current.getDate() + 10);
  // let dateEx = new Date(current).toLocaleDateString("de");

  async function getList() {
    const get = headApi + `/user/+${clientid ? clientid : "919051979509"}`;
    const results = await fetch(get);
    const res = await results.json();
    if (res.message === "Mobile Number Not Found") {
      history.push("/error-page");
      // console.clear()
    }
    setUserId(res.id);
    // const list = headApi + `/cart/byClientid?userid=${res.referenceid}&clientid=${res.id}`
    const list = headApi + `/cart/byInterval?userid=1&clientid=${res.id}`
    const result = await fetch(list);
    const data = await result.json();
    // setAddCart(data && data.CartData ? data.CartData : history.push("/"));
    if (data.error === "true") {
      setLoad(false)
      history.push("/error-page");
      // console.clear()
    } else {
      setLoad(true)
      setAddCart(data && data.CartData ? data.CartData : history.push("/error-page"));
      const UpDate = data && data.CartData ? data.CartData[0].timedate.update : ""
      const news = new Date(UpDate)
      const getDate = new Date(new Date(news).setDate(new Date(news).getDate() + 3));
      setUpdateDate(getDate.toLocaleDateString("de"));
    }
  }

  useEffect(() => {
    getList();
  }, []);

  const handleitemRemove = (c, submitted) => {
    setSubmitted(true)
  }

  const handleConfirm = () => {
    // console.log(cardId);
    axios.delete(headApi + `/cart?id=${cardId}&clientid=${userId}`)
      .then(res => {
        // console.log(res.data);
        // if (res.message === "Data Deleted Successfully!!! ") {
        //   setSubmittedConfirm(true)
        // window.location.reload(false);
        // }
      })
    setSubmittedConfirm(true)
  };

  const hideAlert = () => {
    setSubmitted(false);
    setSubmittedConfirm(false);
    window.location.reload(false);
  };

  var totalCal = 0;
  var totalCalMix = 0;
  var totalSum = 0;

  return (
    <div className={classes.productPage}>
      <Helmet>
        <title>Cart</title>
      </Helmet>
      {load ?
      <div className={classes.container}
        style={{ border: "1px solid #000000" }}
      >
        {submitted ? (
          <SweetAlert
            warning
            type={alertType}
            style={{ display: "block", marginTop: "100px" }}
            title="Are you sure?"
            onConfirm={handleConfirm}
            onCancel={() => hideAlert()}
            confirmBtnCssClass={
              classeAlert.button + " " + classeAlert.success
            }
            cancelBtnCssClass={classeAlert.button + " " + classeAlert.danger}
            confirmBtnText="Yes, delete it!"
            cancelBtnText="Cancel"
            showCancel
          />
        ) : null}

        {submittedConfirm ? (
          <SweetAlert
            success
            style={{ display: "block", marginTop: "100px" }}
            title="Deleted!"
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
          >
            Your imaginary file has been deleted.
          </SweetAlert>
        ) : null}

        <BillHeader />
        <ClientDetails />
        <Table
          tableHead={[
            <span className={classes.tableHead} key="sr">
              Sr.
              <br />
              No.
            </span>,
            "",
            <span className={classes.tableHead} key="des">Description of Goods</span>,
            <span className={classes.tableHead + " " + classes.headRight} key="qty">
              Quantity
            </span>,
            <span className={classes.tableHead + " " + classes.headRight} key="pri">
              Price
            </span>,
            <span className={classes.tableHead + " " + classes.headRight} key="amt">
              Amount
            </span>,
            "",
          ]}
          tableData={[
            ...addCart.map((c, index) => (
              [
                <span className={classes.listNumber} key={c.id}>{index + 1}</span>,
                <div className={classe.imgContainer} key={c.id}>
                  {/* Date: {c.timedate.date.slice(0, -12)} */}
                  Date: {new Date(c.timedate.date).toLocaleDateString("de")}
                  {c.design1.img1active === 1 ? (
                    <img
                      src={imgApi + "" + c.design1.image1}
                      alt="..."
                      className={classe.img}
                    />
                  ) : c.design2.img2active === 1 ? (
                    <img
                      src={imgApi + "" + c.design2.image2}
                      alt="..."
                      className={classe.img}
                    />
                  ) : c.design3.img3active === 1 ? (
                    <img
                      src={imgApi + "" + c.design3.image3}
                      alt="..."
                      className={classe.img}
                    />
                  ) : c.design4.img4active === 1 ? (
                    <img
                      src={imgApi + "" + c.design4.image4}
                      alt="..."
                      className={classe.img}
                    />
                  ) : c.design5.img5active === 1 ? (
                    <img
                      src={imgApi + "" + c.design5.image5}
                      alt="..."
                      className={classe.img}
                    />
                  ) : c.design6.img6active === 1 ? (
                    <img
                      src={imgApi + "" + c.design6.image6}
                      alt="..."
                      className={classe.img}
                    />
                  ) : (
                    ""
                  )}
                </div>,
                <span key={c.id}>
                  <small className={classes.listDescription}>
                    {c.platingList.description.slice(8)} {c.cat.description}{" "}
                    {c.catSize.description}{" / Card id "}{c.id}
                  </small>
                  <br />
                  <small className={classes.listDescriptions}>
                    Packing : {c.packing.type}
                  </small>
                  <br />
                  <small className={classes.listDescriptions}>
                    {(
                      c.metalOption.readygram * c.sets.pcs +
                      (c?.mixmmList
                        ? c.mixmmList
                          .map((mix) => mix.sets.pcs)
                          .reduce((a, b) => a + b, 0) *
                        c.mixmmList
                          .map((mix) => mix.metalOption.readygram)
                          .reduce((a, b) => a + b, 0)
                        : 0)
                    ).toFixed(4)}{" "}
                    Avg Gram of{" "}
                    {c.sets.pcs +
                      (c?.mixmmList
                        ? c.mixmmList
                          .map((mix) => mix.sets.pcs)
                          .reduce((a, b) => a + b, 0)
                        : 0)}{" "}
                    {c.sets.setdesc.slice(2)}
                  </small>
                  <br />
                  <small className={classes.listDescription}>
                    Sets Price :{" "}
                    {c.taxCalculation.cash_gst === 0
                      ? (c.taxCalculation.cash / c.box.box).toFixed(2)
                      : (c.taxCalculation.taxincl / c.box.box).toFixed(2)}
                    /-{" "}{c.taxCalculation.cash_gst === 1 ? "IncTax" : ""}
                  </small>
                  <br />
                  <small className={classes.listDescriptions}>
                    Metal Rate : ₹ {c.metal.price}/- Advance : ₹{Math.round(c.metalOption.metalgram * c.sets.pcs * c.box.box * c.total * c.metal.price + (c.mixmmList && c.mixmmList ? c.mixmmList.map((m) => m.metalOption.metalgram * m.sets.pcs * m.metal.price).reduce((a, b) => a + b, 0) * c.box.box * c.total : ""))}
                    /-
                  </small>
                  <br />

                  <GridContainer className={classes.sizePadding}>
                    {c.stocksizes._1x8 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._1x8 === null
                          ? ""
                          : c.stocksizes._1x8 === 0
                            ? ""
                            : "1x8"}
                        <br />
                        {c.stocksizes._1x8 === null
                          ? ""
                          : c.stocksizes._1x8 === 0
                            ? ""
                            : c.stocksizes._1x8}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._1x10 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._1x10 === null
                          ? ""
                          : c.stocksizes._1x10 === 0
                            ? ""
                            : c.indiasize === 1
                              ? "1x10"
                              : "#1"}
                        <br />
                        {c.stocksizes._1x10 === null
                          ? ""
                          : c.stocksizes._1x10 === 0
                            ? ""
                            : c.stocksizes._1x10}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._1x12 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._1x12 === null ? (
                          ""
                        ) : c.stocksizes._1x12 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.indiasize === 1 ? "1x12" : "#2"}
                          </span>
                        )}
                        <br />
                        {c.stocksizes._1x12 === null ? (
                          ""
                        ) : c.stocksizes._1x12 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._1x12}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._1x14 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._1x14 === null ? (
                          ""
                        ) : c.stocksizes._1x14 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            1x14
                          </span>
                        )}
                        <br />
                        {c.stocksizes._1x14 === null ? (
                          ""
                        ) : c.stocksizes._1x14 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._1x14}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._2x0 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._2x0 === null ? (
                          ""
                        ) : c.stocksizes._2x0 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.indiasize === 1 ? "2x0" : "#3"}
                          </span>
                        )}
                        <br />
                        {c.stocksizes._2x0 === null ? (
                          ""
                        ) : c.stocksizes._2x0 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._2x0}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._2x2 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._2x2 === null ? (
                          ""
                        ) : c.stocksizes._2x2 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            2x2
                          </span>
                        )}
                        <br />
                        {c.stocksizes._2x2 === null ? (
                          ""
                        ) : c.stocksizes._2x2 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._2x2}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._2x4 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._2x4 === null ? (
                          ""
                        ) : c.stocksizes._2x4 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.indiasize === 1 ? "2x4" : "#4"}
                          </span>
                        )}
                        <br />
                        {c.stocksizes._2x4 === null ? (
                          ""
                        ) : c.stocksizes._2x4 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._2x4}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._2x6 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._2x6 === null ? (
                          ""
                        ) : c.stocksizes._2x6 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            2x6
                          </span>
                        )}
                        <br />
                        {c.stocksizes._2x6 === null ? (
                          ""
                        ) : c.stocksizes._2x6 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._2x6}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._2x8 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._2x8 === null ? (
                          ""
                        ) : c.stocksizes._2x8 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.indiasize === 1 ? "2x8" : "#5"}
                          </span>
                        )}
                        <br />
                        {c.stocksizes._2x8 === null ? (
                          ""
                        ) : c.stocksizes._2x8 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._2x8}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._2x10 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._2x10 === null ? (
                          ""
                        ) : c.stocksizes._2x10 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.indiasize === 1 ? "2x10" : "#6"}
                          </span>
                        )}
                        <br />
                        {c.stocksizes._2x10 === null ? (
                          ""
                        ) : c.stocksizes._2x10 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._2x10}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._2x12 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._2x12 === null ? (
                          ""
                        ) : c.stocksizes._2x12 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.indiasize === 1 ? "2x12" : "#7"}
                          </span>
                        )}
                        <br />
                        {c.stocksizes._2x12 === null ? (
                          ""
                        ) : c.stocksizes._2x12 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._2x12}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._2x14 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._2x14 === null ? (
                          ""
                        ) : c.stocksizes._2x14 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            2x14
                          </span>
                        )}
                        <br />
                        {c.stocksizes._2x14 === null ? (
                          ""
                        ) : c.stocksizes._2x14 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._2x14}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                    {c.stocksizes._3x0 !== 0 ? (
                      <span
                        className={
                          classes.textCenter +
                          " " +
                          classes.sizeSpan +
                          " " +
                          classes.listDescriptionMM
                        }
                      >
                        {c.stocksizes._3x0 === null ? (
                          ""
                        ) : c.stocksizes._3x0 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.indiasize === 1 ? "3x0" : "#8"}
                          </span>
                        )}
                        <br />
                        {c.stocksizes._3x0 === null ? (
                          ""
                        ) : c.stocksizes._3x0 === 0 ? (
                          ""
                        ) : (
                          <span
                            className={
                              classes.textCenter +
                              " " +
                              classes.sizeSpan +
                              " " +
                              classes.listDescriptionMM
                            }
                          >
                            {c.stocksizes._3x0}
                          </span>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                  </GridContainer>
                  <span className={classes.listDescription}>{c && c.name ? c.name + ", " : ""} {c && c.mycomment ? c.mycomment : ""}</span>
                </span>,
                <span
                  className={classes.headRight + " " + classes.listNumber}
                  key={c.id}
                >
                  {c.total}
                </span>,
                <span
                  className={classes.headRight + " " + classes.listNumber}
                  key={c.id}
                >
                  ₹
                  {c.taxCalculation.cash_gst === 0
                    ? c.taxCalculation.cash
                    : c.taxCalculation.taxincl}
                </span>,
                <span
                  className={classes.headRight + " " + classes.listNumber}
                  key={c.id}
                >
                  ₹{Math.round(c.taxableamt)}
                </span>,
                <Tooltip
                  id="close1"
                  title="Cart Remove"
                  placement="left"
                  classes={{ tooltip: classe.tooltip }}
                  key={c.id}
                >
                  <Button
                    link
                    className={classe.actionButton}
                  // onClick={() => handleitemRemove(c.id)}
                  >
                    <Close style={{ color: "red" }} />
                  </Button>
                </Tooltip>,
              ]
            )),
            [
              "",
              <span className={classes.listNumber} key={1}>Cartoon Charges<br />Grand Total</span>,
              <span className={classes.listNumber} key={2}><br />
              {addCart.map((c) => {
                  totalCal = totalCal + c.metalOption.metalgram * c.sets.pcs * c.box.box * c.total * c.metal.price;
                  return (
                    c.mixmmList && c.mixmmList ? c.mixmmList.map((m) => {
                      totalCalMix = totalCalMix + m.metalOption.metalgram * m.sets.pcs * m.metal.price * c.box.box * c.total;
                      totalSum = totalCalMix + totalCal
                      return (
                        ""
                      )
                    }) : ""
                  )
                })}
                Advance - ₹{Math.round(totalSum = totalCalMix + totalCal) + "/-"}</span>,
              <span key={3}>
                <span className={classes.headRight + " " + classes.listNumber}>CRTN-{addCart.reduce((a, b) => parseInt(a) + parseInt(b.ctnquantity), 0)}</span><br />
                <span className={classes.headRight + " " + classes.listNumber}>Box-{addCart && addCart.reduce((a, b) => a + b.total, 0)}</span>
              </span>,
              "",
              <span key={4}>
                <span className={classes.headRight + " " + classes.listNumber}>₹{addCart.reduce((a, b) => a + b.totalcartoncharge, 0) + "/-"}</span><br />
                <span className={classes.headRight + " " + classes.listNumber}>₹{Math.round(addCart.reduce((a, b) => a + b.taxableamt + b.totalcartoncharge, 0)) + "/-"}</span>
              </span>,
              ""
            ]

          ]}
        />
        <hr />
        <GridItem className={classes.textCenter}>
          <h5><strong>Terms & Condition</strong></h5>
        </GridItem>
        <hr />
        <GridContainer>
            <GridItem className={classes.condition}>
              <ol>
              <li>The order will be delivered within 25 working days in India from the date of payment and <br /> it will take minimum 90 working days to be delivered outside India.</li>
                <li>Advance{" "}
                  <span className={classes.termDescription}>
                    Rs.{" "}
                    {Math.round(totalSum)}
                    /-
                  </span>{" "}
                 payment will have to be made for the metal at the time of order. </li>
                <li>When the goods will be ready. The making charges will have to be paid for the goods being dispatched on the first shipment.  After that, when the second shipment takes place, its making charges will have to be paid.</li>
                <li>There will be two shipments of goods.</li>
                <li>Packing charges and transport charges will be extra.</li>
                <li>If you want to cover the insurance, then 3% extra will have to be paid on the purchase amount.</li>
                <li>Proposal is valid till{" "}
                  <span className={classes.termDescription}>
                    {updateDate}
                  </span>{" "}
                  from,</li>
              </ol>
            </GridItem>
          </GridContainer>
        <div className={classes.brand}>
          <Button className={classes.print} color="info" round onClick={() => window.print()}>Print</Button>
          <span style={{ marginLeft: "10px" }}><Button className={classes.print} color="info" round onClick={() => setLoginModal(true)}>Proceed Order</Button></span>
        </div>
      </div>
      : "" }

      <GridItem xs={12} sm={6} md={6} lg={6}>
        <Dialog
          classes={{
            root: classPop.modalRoot,
            paper: classPop.modal + " " + classPop.modalLogin,
          }}
          open={loginModal}
          TransitionComponent={Transition}
          keepMounted
          // onClose={() => setLoginModal(false)}
          aria-labelledby="login-modal-slide-title"
          aria-describedby="login-modal-slide-description"
        >
          <Card plain className={classPop.modalLoginCard}>
            <DialogTitle
              id="login-modal-slide-title"
              disableTypography
              className={classPop.modalHeader}
            >
              <CardHeader
                plain
                color="primary"
                className={
                  classPop.textCenter + " " + classPop.cardLoginHeader
                }
              >
                <Button
                  simple
                  className={classPop.modalCloseButton}
                  key="close"
                  aria-label="Close"
                  onClick={() => setLoginModal(false)}
                >
                  {" "}
                  <Close className={classPop.modalClose} />
                </Button>
                <h5 className={classPop.cardTitleWhite}>Log in</h5>
                <div className={classPop.socialLine}>
                  <Button
                    justIcon
                    link
                    className={classPop.socialLineButton}
                  >
                    <i className="fab fa-facebook-square" />
                  </Button>
                  <Button
                    justIcon
                    link
                    className={classPop.socialLineButton}
                  >
                    <i className="fab fa-twitter" />
                  </Button>
                  <Button
                    justIcon
                    link
                    className={classPop.socialLineButton}
                  >
                    <i className="fab fa-google-plus-g" />
                  </Button>
                </div>
              </CardHeader>
            </DialogTitle>
            <DialogContent
              id="login-modal-slide-description"
              className={classPop.modalBody}
            >
              {!otpScreen ? (
                <form>
                  <p
                    className={
                      classPop.description + " " + classPop.textCenter
                    }
                  >
                    Welcome
                  </p>
                  <CardBody className={classPop.cardLoginBody}>
                    <PhoneInput
                      // style={mystyle}
                      inputStyle={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid #040000 ",
                        borderRadius: "0",
                      }}
                      country={"in"}
                      name="mobile"
                      value={mobile}
                      // onChange={(mobile) => handleMobileNumber(mobile)}
                      onChange={(mobile) => {
                        setMobile(
                          mobile.length <= 12 ? mobile : mobile
                        );
                        setMobileErr("");
                      }}
                      required={true}
                    />
                    <span style={{ color: "red" }}>{mobileErr}</span>
                  </CardBody>
                  <br />
                  <div className={classes.textCenter}>
                    <Button
                      simple
                      color="info"
                      size="lg"
                      onClick={handleSendOtp}
                    >
                      Log in with OTP
                    </Button>
                  </div>
                  <div className={classes.textCenter}>
                    <Button
                      simple
                      color="info"
                      size="lg"
                      href="/bangles-sign-up"
                    >
                      Create New Account
                    </Button>
                  </div>
                </form>
              ) : (
                <form>
                  <p
                    className={
                      classPop.description + " " + classPop.textCenter
                    }
                  >
                    6 digit OTP SMS sent on your mobile
                  </p>
                  <p
                    className={
                      classPop.description + " " + classPop.textCenter
                    }
                  >
                    {otp}
                  </p>
                  <p
                    className={
                      classPop.description + " " + classPop.textCenter
                    }
                  >
                    {reSend}
                  </p>
                  <CardBody className={classPop.cardLoginBody}>
                    <CustomInput
                      id="otpNumber"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "otpNumber",
                        value: otpNumber,
                        onChange: (e) => handleOtp(e),
                        placeholder: "Enter OTP here",
                        type: "text",
                        // endAdornment: (
                        //   <InputAdornment position="end">
                        //     <Icon className={classes.inputIconsColor}>
                        //       lock_utline
                        //     </Icon>
                        //   </InputAdornment>
                        // ),
                        autoComplete: "off",
                      }}
                      required={true}
                    />
                    <p
                      className={
                        classes.description + " " + classes.textCenter
                      }
                    >
                      {otpNumberErr}
                    </p>
                  </CardBody>
                  <div className={classes.textCenter}>
                    <Button
                      simple
                      color="info"
                      size="lg"
                      onClick={handleLogin}
                    >
                      Log in
                    </Button>
                    <Button
                      simple
                      color="info"
                      size="lg"
                      onClick={handleCall}
                    >
                      <FiPhoneCall />
                      Call Me
                    </Button>
                  </div>
                  <p
                    className={
                      classes.description + " " + classes.textCenter
                    }
                  >
                    {" "}
                    Didn't receive the OTP yet?{" "}
                    <span style={{ marginLeft: "10px" }}>
                      <a href="#" onClick={handleSendOtp}>
                        Resend OTP
                      </a>
                    </span>
                  </p>
                </form>
              )}
            </DialogContent>
          </Card>
        </Dialog>
      </GridItem>
    </div>
  );
}
